/**
 * useToast — простое эфемерное уведомление (тост). `notify(text)` показывает
 * сообщение и само гасит его через `duration`. Таймер чистится при новом
 * вызове и при размонтировании — без утечек и «наложений».
 */

import {useCallback, useEffect, useRef, useState} from 'react';

export const useToast = (defaultDuration = 1800) => {
  const [toast, setToast] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const notify = useCallback(
    (message: string, duration = defaultDuration) => {
      clearTimeout(timer.current);
      setToast(message);
      timer.current = setTimeout(() => setToast(null), duration);
    },
    [defaultDuration],
  );

  useEffect(() => () => clearTimeout(timer.current), []);

  return {toast, notify};
};
